{
  "sources": ["meischke-burgerweeshuis", "meischke-burgerweeshuis-huizen", "painting-1538"],
  "note": "Meischke chapters 4 and 5 identify six rented kamers beside the Begijnensloot and three Kalverstraat houses (later numbers 86, 88 and 90) acquired in 1480, which the city required to remain rental homes. The rear ground served the convent's cow house by 1500. The later plans suggest low front rooms and lower rear rooms in the six kamers, and long, single-storey three-part Kalverstraat homes; their use as evidence for 1538 is interpretive. Chainages, individual widths, depths, shear, heights, roofs, openings, annexes, cow-house mass and private-ground limits are estimated. Later 1568 houses, 1581 entrance/corner rebuilding, 1591 cow house and 1716 street front are not backdated. The modern house numbers identify the historical property sequence, not surveyed 1538 corners.",
  "rows": [
    {
      "id": "lucien-kamers",
      "source": "street-sint-luciensteeg-2",
      "side": "right",
      "from": 3,
      "to": 31,
      "depth": 6.5,
      "shear": 0,
      "evidence": "inferred",
      "houses": [
        {
          "id": "lucien-kamer-western-1",
          "widthWeight": 1.08,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lucien-kamer-western-2",
          "widthWeight": 0.95,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lucien-kamer-middle-1",
          "widthWeight": 1,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lucien-kamer-middle-2",
          "widthWeight": 1,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lucien-kamer-eastern-1",
          "widthWeight": 0.93,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lucien-kamer-eastern-2",
          "widthWeight": 1.08,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        }
      ]
    },
    {
      "id": "lucien-kalverstraat-rentals",
      "source": "street-kalverstraat",
      "side": "left",
      "from": 158.5,
      "to": 176.5,
      "depth": 17.5,
      "shear": -1.1,
      "evidence": "inferred",
      "houses": [
        {
          "id": "lucien-kalverstraat-90-before-1581",
          "widthWeight": 1,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lucien-kalverstraat-88",
          "widthWeight": 1.05,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lucien-kalverstraat-86",
          "widthWeight": 0.98,
          "storeys": 1,
          "roof": "tile",
          "gable": "plain"
        }
      ]
    }
  ],
  "cowHouse": {
    "center": [-110.5, -300],
    "headingDeg": 37,
    "length": 15.5,
    "width": 4.8,
    "storeyHeight": 3.2
  },
  "privateGround": [
    [-118.5, -275.4],
    [-90.2, -268.15],
    [-91.5, -279],
    [-94, -294],
    [-102, -315],
    [-108, -324],
    [-125, -324],
    [-121, -305],
    [-116.5, -283]
  ]
}
